import type { SVGProps } from "react";
import { forwardRef } from "react";

function SvgMembershipGreenColored(props: SVGProps<SVGSVGElement>, ref: React.Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.0801 1.70898C11.6925 0.0966006 14.3075 0.0965998 15.9199 1.70898L16.1914 1.98145C16.7782 2.5682 17.5745 2.89746 18.4043 2.89746H18.4736C20.7537 2.89759 22.6024 4.7463 22.6025 7.02637V7.0957C22.6025 7.9255 22.9318 8.72184 23.5186 9.30859L23.791 9.58008C25.4034 11.1925 25.4034 13.8075 23.791 15.4199L23.5186 15.6914C22.9318 16.2782 22.6025 17.0745 22.6025 17.9043V17.9736C22.6024 20.2537 20.7537 22.1024 18.4736 22.1025H18.4043C17.5745 22.1025 16.7782 22.4318 16.1914 23.0186L15.9199 23.291C14.3075 24.9034 11.6925 24.9034 10.0801 23.291L9.80859 23.0186C9.22183 22.4318 8.4255 22.1025 7.5957 22.1025H7.52637C5.2463 22.1024 3.39759 20.2537 3.39746 17.9736V17.9043C3.39746 17.1264 3.10854 16.3777 2.58887 15.8037L2.48145 15.6914L2.20898 15.4199C0.5966 13.8075 0.5966 11.1925 2.20898 9.58008L2.48145 9.30859L2.58887 9.19629C3.10854 8.62235 3.39746 7.87363 3.39746 7.0957V7.02637C3.39759 4.7463 5.2463 2.89759 7.52637 2.89746H7.5957C8.4255 2.89746 9.22184 2.5682 9.80859 1.98145L10.0801 1.70898Z"
        fill="url(#paint0_linear_721_5245)"
        stroke="#FFB7B7"
      />
      <path
        d="M7.732 10.0641L12.7186 7.32126C12.8048 7.27387 12.9015 7.24902 12.9998 7.24902C13.0981 7.24902 13.1948 7.27387 13.281 7.32126L18.2676 10.0641C18.3391 10.1034 18.4015 10.1572 18.4509 10.2222C18.5003 10.2871 18.5355 10.3616 18.5542 10.441C18.573 10.5204 18.5749 10.6028 18.5599 10.683C18.5448 10.7632 18.5131 10.8393 18.4668 10.9064L13.4799 18.1368C13.4262 18.2146 13.3545 18.2781 13.2709 18.322C13.1873 18.3659 13.0942 18.3888 12.9998 18.3888C12.9054 18.3888 12.8123 18.3659 12.7287 18.322C12.6451 18.2781 12.5734 18.2146 12.5197 18.1368L7.5328 10.9067C7.48649 10.8396 7.45478 10.7635 7.43972 10.6833C7.42466 10.6031 7.42657 10.5207 7.44535 10.4413C7.46412 10.3619 7.49933 10.2874 7.54871 10.2224C7.59808 10.1575 7.66053 10.1037 7.732 10.0644V10.0641Z"
        fill="url(#paint1_linear_721_5245)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_721_5245"
          x1="7.825"
          y1="1"
          x2="13"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2E8" />
          <stop offset="1" stopColor="#F7D0D0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_721_5245"
          x1="9.28639"
          y1="8.6415"
          x2="12.9995"
          y2="18.3889"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82090F" />
          <stop offset="1" stopColor="#B0676A" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgMembershipGreenColored);
export default ForwardRef;
